<template>
  <BaseModal
    ref="baseModal"
    v-if="keyManagement"
    icon="mdi-key"
    :onCloseHook="onCloseHook"
    :onOpenHook="onOpenHook"
    minHeight="553px"
    modalWidth="840px"
    hook-sufix="KeysModal"
    modalTransition="slide-x-transition"
  >
    <template #content>
      <div
        class="text-h5"
        style="position: absolute; top: 0; padding-top: 33px"
      >
        <v-icon class="pr-2" large color="primary">mdi-key</v-icon>
        <span style="font-weight: 500">
          {{ $t('message.pages.live.key') }}</span
        >
      </div>

      <div>
        <p class="mb-7">
          {{ $t('message.pages.live.chooseKey') }}
        </p>
      </div>
      <div style="display: flex; justify-content: center">
        <v-skeleton-loader
          v-if="keyLoading"
          type="image"
          height="30px"
          width="60px"
          style="margin-top: 4px; margin-right: 90px"
        ></v-skeleton-loader>

        <v-skeleton-loader
          v-if="keyLoading"
          type="image"
          height="30px"
          width="70px"
          style="margin-top: 4px; margin-right: 370px"
        ></v-skeleton-loader>

        <v-skeleton-loader
          v-if="keyLoading"
          type="image"
          height="30px"
          width="90px"
          style="margin-top: 4px"
        ></v-skeleton-loader>
      </div>
      <div v-if="keyLoading">
        <v-skeleton-loader
          v-for="index in numberOfLoaders"
          :key="index"
          type="image"
          height="30px"
          width="100%"
          style="
            margin-top: 4px;
            padding-bottom: 5px;
            display: block;
            margin-left: auto;
            margin-right: auto;
          "
        ></v-skeleton-loader>
      </div>

      <!-- list -->
      <div
        v-if="!keyLoading"
        style="
          max-height: 323px;
          min-height: 300px;
          overflow-x: hidden;
          text-align: center;
        "
      >
        <table class="table mb-6" style="width: 100%">
          <!-- head -->
          <thead class="keys-content">
            <tr>
              <th />
              <th>{{ $t('message.pages.live.keyName') }}</th>
              <th class="live-title">{{ $t('message.pages.live.key') }}</th>
              <th class="live-title">
                {{ $t('message.pages.live.situation') }}
              </th>
            </tr>
          </thead>

          <tbody>
            <GenerateKeysModal />
            <template v-if="list.keys.length">
              <tr
                v-for="(key, index) in list.keys"
                :key="index"
                class="tr-item"
                :class="{ 'is-clickable': !isEditing }"
                @click="handleRowClick({ e: $event, index })"
              >
                <td data-name="check" class="is-narrow key-number">
                  <span>{{ index + 1 }}</span>
                </td>
                <td
                  data-name="name"
                  class="is-narrow key-name ml-auto"
                  style="max-width: 120.88px; text-align: start"
                >
                  <span
                    class="ml-auto truncate-text"
                    v-if="key.title.length < 12"
                  >
                    {{ key.title }}
                    <v-icon
                      v-if="key.default"
                      small
                      style="color: #ffc107; margin-bottom: 3px"
                    >
                      mdi-star
                    </v-icon>
                  </span>
                  <v-tooltip bottom v-else>
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        class="ml-auto truncate-text"
                        v-bind="attrs"
                        v-on="on"
                      >
                        {{ key.title }}
                        <v-icon
                          v-if="key.default"
                          small
                          style="color: #ffc107; margin-bottom: 3px"
                        >
                          mdi-star
                        </v-icon>
                      </span>
                    </template>
                    <span>{{ key.title }}</span>
                  </v-tooltip>
                </td>
                <td data-name="key" class="key-value">
                  <div class="d-flex justify-content-center align-items-center">
                    <span style="width: 340px">
                      {{
                        showKeyIndices.includes(index)
                          ? key.stream_key
                          : '*'.repeat(key.stream_key.length)
                      }}
                    </span>
                    <base-btn
                      style="
                        justify-content: center;
                        align-items: center;
                        justify-content: center;
                      "
                      :icon="
                        showKeyIndices.includes(index)
                          ? 'mdi-eye-off'
                          : 'mdi-eye'
                      "
                      class="ml-auto pt-0 pb-0 eye-icon"
                      type="tertiary"
                      @click="handleShowKey({ e: $event, index })"
                    />
                  </div>
                </td>
                <td data-name="status" class="is-narrow mr-3 d-flex">
                  <span
                    class="chip mt-2 mb-4"
                    :class="[key.is_attached ? 'is-in-use' : 'is-free']"
                  >
                    {{
                      key.is_attached
                        ? $t('message.pages.live.inUse')
                        : $t('message.pages.live.free')
                    }}
                  </span>

                  <base-btn
                    @click="openEditModal(key.id, key.title, key.stream_key)"
                    style="position: relative; top: 3px"
                    class="ml-8 pencil-icon"
                    icon="mdi-pencil"
                    type="tertiary"
                  />
                </td>

                <!-- <td data-name="status" class="is-narrow mr-3" style="text-align: center;">
  <span class="chip" :class="[key.is_attached ? 'is-in-use' : 'is-free']">
    {{ key.is_attached ? 'In use' : 'Free' }}
  </span>

  <base-btn @click="openEditModal(key.id, key.title)" class="ml-8" icon="mdi-pencil"
    type="tertiary" style="display: inline-flex; align-items: center; height: 100%;" />
</td> -->
              </tr>
              <aside>
                <EditKeysModal
                  ref="editModal"
                  @keyUpdated="handleKeyUpdated"
                  @keyDeleted="handleKeyDeleted"
                />
              </aside>
            </template>

            <!-- new -->
            <tr v-if="!reachKeyLimit">
              <td data-name="check" class="is-narrow">
                <span>{{ list.keys.length + 1 }}</span>
              </td>
              <td data-name="name" colspan="2" style="text-align: start">
                <span
                  style="color: var(--v-neutral-lighten2); font-weight: 400"
                  >{{ $t('message.pages.live.keySpace') }}</span
                >
              </td>
              <td data-name="status" class="is-narrow">
                <base-btn
                  class="mr-8"
                  :loading="isLoading"
                  style="min-height: 40px"
                  @click="openGenerateModal()"
                >
                  {{ $t('message.pages.live.generateKey') }}
                </base-btn>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
    <!-- actions -->
    <template #card-actions>
      <v-skeleton-loader
        v-if="keyLoading"
        type="image"
        height="40px"
        width="100%"
        style="margin-top: 20px; margin-bottom: 36px"
      ></v-skeleton-loader>
      <v-card-actions
        v-if="!keyLoading"
        class="pt-3 pb-9 px-0 d-flex justify-content-center"
      >
        <v-icon class="mr-3" color="primary-base"> mdi-key </v-icon>
        <span
          v-if="!reachKeyLimit && totalKeys > 1"
          class="warning-plan"
          style="color: var(--v-neutral-base)"
          >{{ $t('message.pages.live.keyAmount') }} {{ totalKeys }}
          {{ $t('message.pages.live.keyAmount2') }}</span
        >

        <span
          v-if="!reachKeyLimit && totalKeys < 2"
          class="warning-plan"
          style="color: var(--v-neutral-base)"
          >{{ $t('message.pages.live.keyAmount') }} {{ totalKeys }}
          {{ $t('message.pages.live.keyAmount3') }}</span
        >

        <span v-if="reachKeyLimit">
          {{ $t('message.pages.live.limitKey') }} ({{ totalKeys }})
        </span>

        <!-- buy -->
        <base-btn class="ml-auto" type="secondary" @click="goPlan">
          {{ $t('message.pages.live.buyKeys') }}
        </base-btn>
      </v-card-actions>
    </template>
  </BaseModal>
</template>

<script>
// external imports

// internal imports

// API
import liveStreamKeyApi from '@/services/liveStreamKeyApi'
import BaseModal from '@/components/BaseModal.vue'
import planApi from '@/services/planApi'

// Components

export default {
  name: 'KeysModal',
  components: {
    BaseModal,
    BaseBtn: () => import('@/components/BaseBtn.vue'),
    EditKeysModal: () => import('./EditKeysModal.vue'),
    GenerateKeysModal: () => import('./GenerateKeysModal.vue'),
  },
  data: () => ({
    userName: '',
    additionalKeys: 0,
    planKeys: 0,
    slotLiveAddon: 0,
    numberOfLoaders: 8,
    subscriptionName: '',
    totalKeys: 0,
    showKeyIndices: [],
    keysLength: 0,
    isEditing: false,
    keyLoading: true,
    isLoading: false,
    openModal: false,
    keyManagement: true,
    reachKeyLimit: false,
    form: {
      title: '',
      selected: null,
      showKeyIndex: null,
    },
    list: {
      keys: [],
    },
  }),
  computed: {
    // ...
  },
  watch: {
    isEditing() {
      this.form.title = ''
      ;(this.form.selected = null), (this.form.showKeyIndex = null)
    },
    open(val) {
      if (!val) this.handleClose()
    },
  },
  mounted() {
    this.loadData()
    this.loadPlanData()
  },
  methods: {
    rules() {
      const i18n = this.$i18next

      return {
        required: (v) => (v && !!v) || i18n.t('message.requiredField'),
        max: (v) =>
          (v && v.length <= 255) || i18n.t('message.maximumLengthVideo'),
        min: (v) => v.length >= 3 || i18n.t('message.pages.live.titleLimit'),
      }
    },
    closeMyModal() {
      this.$refs.baseModal.handleClose()
    },
    handleShowKey({ e, index }) {
      if (e) {
        e.preventDefault()
        e.stopPropagation()
      }

      if (this.showKeyIndices.includes(index)) {
        this.showKeyIndices = this.showKeyIndices.filter((i) => i !== index)
      } else {
        this.showKeyIndices.push(index)
      }
    },

    openEditModal(keyId, keyName, keyStreamKey) {
      this.$root.$emit('openEditKeysModal', keyId, keyName, keyStreamKey)
      this.closeMyModal()
    },
    async handleKeyUpdated() {
      await this.loadData()
    },

    async handleKeyDeleted() {
      await this.loadData()
    },

    checkLimit() {
      if (this.keysLength < this.totalKeys) {
        this.reachKeyLimit = false
      } else {
        this.reachKeyLimit = true
      }
    },

    openGenerateModal() {
      this.$root.$emit('openGenerateKeysModal')
      this.closeMyModal()
    },
    handleRowClick({ e, index }) {
      if (e) {
        e.preventDefault()
        e.stopPropagation()
      }

      if (this.isEditing) return

      if (this.form.selected === null) {
        this.form.selected = index
      } else {
        this.form.selected = null
      }

      this.showKeyIndices = []
    },

    async onOpenHook() {
      this.loadData()
      this.loadPlanData()
    },

    onCloseHook() {
      this.isEditing = false
    },
    goPlan() {
      this.onCloseHook()
      this.$router.push({ name: 'Cart' })
    },
    selectKey() {
      this.onCloseHook()

      const selectedKeyId = this.list.keys[this.form.selected].id
      const selectedKey = this.list.keys.find((key) => key.id === selectedKeyId)

      if (selectedKey) {
        selectedKey.is_online = true
        this.$emit('selected-live-stream-key', selectedKeyId)
      }

      this.$root.$emit('closeLiveKeysModal')
    },

    async loadData() {
      try {
        const { data } = await liveStreamKeyApi.getAllLiveStreamKey()
        this.list.keys = data
        this.keysLength = this.list.keys.length
        this.keyLoading = false
      } catch (err) {
        console.error('e', err)
      }
    },

    async generateKey() {
      const { title } = this.form

      this.isLoading = true

      try {
        const { data } = await liveStreamKeyApi.createLiveStreamKey({ title })
        this.list.keys.push(data)
      } catch (err) {
        console.log(err)
      } finally {
        this.onCloseHook()
        this.isLoading = false
      }
    },

    async loadPlanData() {
      try {
        const { data } = await planApi.getSubscription()
        const subscriptionName = data.subscriptions.name
        const slotLiveAddon =
          (data.addons &&
            data.addons.slot_live &&
            data.addons.slot_live[0] &&
            data.addons.slot_live[0].quantity) ||
          0

        this.subscriptionName = subscriptionName
        this.slotLiveAddon = slotLiveAddon
        this.userName = data.name
        if (subscriptionName == 'Gold') {
          this.planKeys = 2
        } else {
          this.planKeys = 1
        }
        this.totalKeys = this.planKeys + slotLiveAddon
        this.checkLimit()
      } catch (e) {
        this.error = true
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.eye-icon {
  color: #585d83;
}

.truncate-text {
  display: block;
  width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tr-item:hover {
  background-color: var(--v-brand-lighten2);

  .eye-icon {
    background-color: var(--v-brand-lighten2);
    border-color: var(--v-brand-lighten2);
  }

  .pencil-icon {
    pointer-events: all;
    background-color: var(--v-brand-lighten2);
    border-color: var(--v-brand-lighten2);
    opacity: 1;
    transition: opacity 0.3s ease;
  }

  .chip {
    transition: opacity 1s ease;
  }
}

.pencil-icon {
  opacity: 0;
  pointer-events: none;
}

.tr-item {
  height: 63px;
}

@import '@/assets/scss/src/table';

::v-deep {
  @import '@/assets/scss/src/new-live';

  .v-text-field fieldset,
  .v-text-field .v-input__control {
    border-color: var(--v-neutral-lighten2);
    color: var(--v-neutral-base);
  }

  .is-clickable {
    cursor: pointer;
  }

  .chip {
    padding: 2px 8px 2px 8px;
    margin-left: 35px;
    height: 25px;
    border-radius: 30px;
    justify-content: center;
    align-items: center;

    font: {
      family: Rubik;
      size: 14px;
      style: normal;
      height: 150%;
    }

    &.is-in-use {
      color: var(--v-brand-base);
      background: var(--v-neutral-lighten3);
    }

    &.is-free {
      color: #1b5e20;
      background: #c8e6c9;
    }
  }

  .live-title {
    padding-left: 50px !important;
  }

  .scrollable {
    max-height: 100px;
    overflow-x: auto !important;
  }

  th {
    font-size: 14px !important;
    color: var(--v-neutral-lighten1) !important;
    font-weight: 500px !important;
    line-height: 21px !important;
  }
}
.bg-dark {
  .table {
    background-color: var(--v-neutral-darken2);
  }

  .key-name {
    color: var(--v-neutral-lighten2) !important;
  }

  .key-value {
    color: var(--v-neutral-lighten2) !important;
  }

  .key-number {
    color: var(--v-neutral-lighten2) !important;
  }

  .tr-item:hover {
    background-color: #0f1118;
    .eye-icon {
      background-color: #0f1118;
      border-color: #0f1118;
    }

    .pencil-icon {
      background-color: #0f1118;
      border-color: #0f1118;
    }
  }
  .warning-plan {
    color: var(--v-neutral-lighten2) !important;
  }
}
</style>
